'use client'
import {useEffect} from 'react'
import * as Sentry from '@sentry/nextjs'
import {ErrorBoundaryFallback} from './_components/ErrorBoundary'
export default function ErrorPage({error}: {error: Error & {digest?: string}}) {
  useEffect(() => {
    // Log the error to Sentry
    Sentry.captureException(error)
  }, [error])

  return <ErrorBoundaryFallback />
}
